import {VcCommunicator} from "/src/visualcrossing-core/vccommunicator";
import {VcGlobal} from "/src/visualcrossing-core/vcglobal_conn";




if (!window.vcCommunicator) {
    window.vcCommunicator=new VcCommunicator({
        "serverroot":VcGlobal.SERVER_ROOT+"/VisualCrossingWebServices/rest/services/",
        "createsessionpkg":{
          requiredStripeProductId: "prod_ElEHd1q0NaQXG8",
          installId: "VCWebsite"
        }
    });
}



